import { connect } from 'react-redux';
import { fetchUserPermissions } from '../../redux/sagas/permission/routines';
import { getIsFetched as getIsFetchedPermissions } from '../../redux/selectors/permission';
import MainLayout from '../../components/MainLayout';

function mapStateToProps(state, props) {
  const hasInit = getIsFetchedPermissions(state);
  return {
    ...props,
    hasInit
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchUserPermissions());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainLayout);
